export default __webpack_public_path__ + "static/media/help-and-support.c75de96b.svg";